export default ({ app }) => {
  const langParam = parseInt(new URLSearchParams(location.search).get('L'));
  //  VueI18n
  if (langParam && typeof langParam === 'number') {
    // Add L-var to initialData, if set in location
    app.$typo3.api.options.endpoints.initialData = '/?type=834&L=' + langParam;
    // VueI18n setLocale in app
  }
};
